import React, { useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import Modal from "./Modal"; // Import the Modal component
import { useLocation } from "react-router-dom";
import "./CSS/CTASection.css";

const CTASection = ({ headingText, buttonText }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const [isModalOpen, setModalOpen] = useState(false); // State to control the modal visibility
  const location = useLocation();

  const buttonStyles = {
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 2s ease-out, transform 2s ease-out",
    fontFamily: "Economica",
    fontSize: "1.5rem",
  };

  const handleOpenModal = () => {
    setModalOpen(true); // Function to open the modal
  };

  const handleCloseModal = () => {
    setModalOpen(false); // Function to close the modal
  };

  return (
    <section className="cta-section text-center py-5 bg-white text-black">
      <h2 style={{ fontFamily: "Roboto" }} className="text-xl font-bold mb-8">
        {headingText}
      </h2>
      <div ref={ref}>
        <button
          onClick={handleOpenModal}
          className="get-in-touch"
          style={buttonStyles}
        >
          {buttonText}
        </button>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        currentPath={location.pathname}
      />
    </section>
  );
};

export default CTASection;
